var exports = {
  "C": "compressedAssigneeAvatar__Cdsj1t",
};

module.exports = exports;
